import yaml from "js-yaml";

/** Map converted DB field names to the YAML structure used for metadata export. */
export const buildMetadataYaml = (convertedData = {}) => ({
  basic: {
    Region: convertedData.region,
    HUC: convertedData.huc,
    City: convertedData.city,
    County: convertedData.county,
    title: convertedData.title,
    "project-name": convertedData.projectName,
    description: convertedData.description,
    purpose: convertedData.purpose,
    creator: convertedData.creator,
    "tdis-identifier": convertedData.tdisIdentifier,
    "keyword-term": convertedData.keywordTerm,
    "update-frequency": convertedData.updateFrequency,
    "use-constraint": convertedData.useConstraint,
  },
  contact: {
    "contact-affiliation": convertedData.contactAffiliation,
    "contact-department": convertedData.contactDepartment,
    "contact-email": convertedData.contactEmail,
    "contact-name": convertedData.contactName,
    "contact-phone-number": convertedData.contactPhoneNumber,
  },
  spatial_information: {
    "spatial-data-type": convertedData.spatialDataType,
    "spatial-extent-decimal-degrees": convertedData.spatialExtentDecimalDegrees,
    "boundary-name": convertedData.boundaryName,
    "horizontal-coordinate-system": convertedData.horizontalCoordinateSystem,
  },
  model: {
    "model-software-name": convertedData.modelSoftwareName,
    "model-software-version": convertedData.modelSoftwareVersion,
    "model-type": convertedData.modelType,
    "other-model-type": convertedData.otherModelType,
    "model-input": convertedData.modelInput,
    "model-output": convertedData.modelOutput,
  },
});

export const serializeMetadataYaml = (convertedData) =>
  yaml.dump(buildMetadataYaml(convertedData));
